import React from 'react';
import { SignatureDigitalSpot } from '@dropbox/dig-illustrations/dist/cjs/spot/signature-digital';
import { ReceiveFaxSpot } from '@dropbox/dig-illustrations/dist/cjs/spot/receive-fax';
import { PAP_View_SignPage } from '@dropbox/pap-events/sign_standalone/view_sign_page';
import { logPAPEvent } from 'js/sign-components/common/product-analytics-pipeline';
import { useSiteCode } from 'js/sign-components/common/use-site-code';
import { NotificationBanners } from 'signer-app/parts/notifications/notification-banners';
import IllustrationLockup from 'signer-app/parts/illustration-lockup';
import { LineDivider } from 'hello-react/components/line-divider';
import MinimalLayout from 'signer-app/parts/minimal-layout';
import { locale } from 'hellospa/common/hs-intl-provider';
import { siteCodes } from 'js/sign-components/common/brand';
import SignUpForm from './sign-up-form';
import CountryDropdown from './country-dropdown';
import { CountryCodeProvider } from 'signer-app/authentication/use-country-code';
import { useProductHomepageURL } from './use-product-homepage-url';
import styles from './authentication.module.scss';

function SignUpPage() {
  const siteCode = useSiteCode();
  const logoHref = useProductHomepageURL(siteCode);

  React.useEffect(() => {
    logPAPEvent(
      PAP_View_SignPage({
        signPage: 'sign_up',
        signSiso: 'regular',
      }),
    );
  }, []);

  const illustration = React.useMemo(() => {
    switch (siteCode) {
      case siteCodes.fax:
        return <ReceiveFaxSpot />;
      // TODO: Waiting for design to decide which illustration to use for
      // Forms. For now, just use the same as Sign.
      case siteCodes.forms:
        return <SignatureDigitalSpot />;
      default:
        return <SignatureDigitalSpot />;
    }
  }, [siteCode]);

  return (
    <MinimalLayout
      locale={locale}
      siteCode={siteCode}
      // Logos on logged out pages should point to the
      // marketing site since the default logo href is
      // /home/index, which requires a session to view.
      logoHref={logoHref}
      contentCentered
    >
      <div className={styles.content}>
        <CountryCodeProvider>
          <NotificationBanners />
          <div className={styles.flexColumnReverse}>
            <div>
              <LineDivider className={styles.footer} />
              <CountryDropdown className={styles.countryCode} />
            </div>
            <IllustrationLockup illustration={illustration}>
              <SignUpForm />
            </IllustrationLockup>
          </div>
        </CountryCodeProvider>
      </div>
    </MinimalLayout>
  );
}

export default SignUpPage;
